import { cn } from 'utils/styles';
import ChimeLogoSvg from '../../../public/icons/chime-logo.svg';

type ChimeLogoColor = 'chime_green' | 'primary_neutral';
type ChimeLogoSize = 'small' | 'large';

interface ChimeLogoProps {
  color?: ChimeLogoColor;
  size?: ChimeLogoSize;
  alt: string;
  className?: string;
}

const SIZE_MAP: Record<ChimeLogoSize, { width: number; height: number }> = {
  small: { width: 66, height: 19 },
  large: { width: 194, height: 56 },
};

const COLOR_MAP: Record<ChimeLogoColor, string> = {
  chime_green: 'text-fern',
  primary_neutral: '',
};

const ChimeLogo = ({ color = 'chime_green', size = 'small', alt, className }: ChimeLogoProps) => {
  const { width, height } = SIZE_MAP[size];
  return (
    <ChimeLogoSvg
      role="img"
      aria-label={alt}
      width={width}
      height={height}
      className={cn(COLOR_MAP[color], className)}
    />
  );
};

export default ChimeLogo;
